export const adSummaryControl = (adSummary) => {
  const adSummaryCheckData = {
    adSummaryData: adSummary,
    buttonTitle: 'Reklam Ver',
    buttonIcon: 'icons-categories-fill',
    buttonHref:
      process.env.NODE_ENV === 'development' ||
      process.env.NODE_ENV === 'branch'
        ? 'https://testso.n11.com/reklam-yonetimi/reklam-ozeti'
        : '/reklam-yonetimi/reklam-ozeti',
  };
  const balance = adSummary?.sellerPointAccount?.content?.[0]?.effectiveBalance ?? 0;
  if (adSummary.existAnyAdsToEndInThreeDays) {
    adSummaryCheckData.title = 'Bitiş tarihi yaklaşan reklamlarınız var.';
    adSummaryCheckData.footerTitle = 'Reklam Özetini Gör';
    adSummaryCheckData.footerTitleHref =
      process.env.NODE_ENV === 'development' ||
      process.env.NODE_ENV === 'branch'
        ? 'https://testso.n11.com/reklam-yonetimi/puan-ozeti'
        : '/reklam-yonetimi/puan-ozeti';
    adSummaryCheckData.footerIcon = 'acil';
  } else if (
    adSummary.gift?.pointAmount === balance && balance > 0
  ) {
    adSummaryCheckData.title = 'Tebrikler! Hediye reklam puanı kazandınız.';
    adSummaryCheckData.gift = true;
  } else if (
    balance > 0 &&
    adSummary.getAdAnalyticsQuery.sellerTotalAdCount > 0
  ) {
    adSummaryCheckData.title = 'Farklı reklam çeşitlerimizi keşfedin.';
    adSummaryCheckData.footerTitle = 'Reklam Rehberini Gör';
    adSummaryCheckData.footerTitleHref =
      process.env.NODE_ENV === 'development' ||
      process.env.NODE_ENV === 'branch'
        ? 'https://testso.n11.com/reklam-yonetimi/reklam-rehberi'
        : '/reklam-yonetimi/reklam-rehberi';
  } else if (
    balance > 0 &&
    adSummary.getAdAnalyticsQuery.sellerTotalAdCount === 0
  ) {
    adSummaryCheckData.title =
      'Hemen ilk reklamınızı oluşturun, satışlarınızı artırın.';
  } else if (
    balance === 0 ||
    adSummary.sellerPointAccount.content.length === 0
  ) {
    adSummaryCheckData.title =
      'Hemen Reklam Puanı satın alın, ürünlerinize reklam vermeye başlayın.';
    adSummaryCheckData.buttonTitle = 'Reklam Puanı Al';
    adSummaryCheckData.buttonIcon = '';
    adSummaryCheckData.buttonHref =
      process.env.NODE_ENV === 'development' ||
      process.env.NODE_ENV === 'branch'
        ? 'https://testso.n11.com/reklam-yonetimi/reklam-ozeti'
        : '/reklam-yonetimi/reklam-ozeti';
  }
  return adSummaryCheckData;
};
